export default __webpack_public_path__ + "static/media/contacts-icon.d6c17f51.svg";